import React from 'react';
import './Loader.css';

const Loader = ({ text = 'Loading...', fullScreen = false }) => {
  const content = (
    <div className="loader-content">
      <div className="loader-orb">
        <div className="orb-core">
          <img src="/loading.gif" alt="" className="orb-logo" />
        </div>
        <div className="orb-ring orb-ring-1"></div>
        <div className="orb-ring orb-ring-2"></div>
        <div className="orb-ring orb-ring-3"></div>
        <div className="orb-particles">
          {[...Array(8)].map((_, i) => (
            <span key={i} className="particle" style={{ '--i': i }}></span>
          ))}
        </div>
      </div>
      <p className="loader-text">{text}</p>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="loader-fullscreen">
        <div className="loader-bg">
          <div className="bg-orb bg-orb-1"></div>
          <div className="bg-orb bg-orb-2"></div>
        </div>
        {content}
      </div>
    );
  }

  return <div className="loader-inline">{content}</div>;
};

export default Loader;
